import store from '@/state/store'

export default async (to, from, next) => {

    //for Server Side Validate.
    if(process.env.VUE_APP_API_VALIDATE_TOKEN == 'serverSide')
    {

        const status = await store.dispatch('auth/validate');

        if(status != 200)
        {
            next({ name: '404'})
        }
    }
    //for Client Side Validate.
    else if(!store.getters['auth/loggedIn']){
        next({ name: '404' })
    }

    //chcek the user must type is wounded.
    let user = store.getters['auth/getUser'];
    
    if(!(user != null && (user.type == 'wounded' || user.type == 'full')))
    {
        next({ name: '404'})
    }

    next({})
}